import React from "react";
import { HtmlSaneado, RevisionSeccion } from "./RevisionSeccion";

export const RevisionPregunta = ({ preguntaHtml, contexto }) => (
  <RevisionSeccion titulo="Pregunta del usuario" icono="person">
    <HtmlSaneado html={preguntaHtml} className="citrus-ia-html--pregunta" />

    {contexto?.length > 0 && (
      <details className="citrus-ia-contexto">
        <summary title="Los mensajes previos de la conversación, por si la pregunta depende de ellos">
          Ver mensajes anteriores para entender la pregunta ({contexto.length})
        </summary>
        <div className="citrus-ia-contexto__hilo">
          {contexto.map((mensaje) => (
            <div
              key={mensaje.Id}
              className={`citrus-gpt-msg citrus-gpt-msg--${mensaje.EsUsuario ? "usuario" : "asistente"}`}
            >
              <span className="citrus-gpt-msg__remitente">{mensaje.EsUsuario ? "Usuario" : "Asistente"}</span>
              <HtmlSaneado html={mensaje.ContenidoHtml} />
            </div>
          ))}
        </div>
      </details>
    )}
  </RevisionSeccion>
);
